import { z } from "zod"
import { ControllerFieldState } from "react-hook-form"

export function minMaxNumber(min?: number, max?: number) {
    let pipe = z.number()
    if (min) {
        pipe = pipe.min(min)
    }
    if (max) {
        pipe = pipe.max(max)
    }
    return pipe
}

export function ensureNumber(numberValidation: z.ZodNumber) {
    return z.preprocess((val) => {
        if (typeof val === "string" && !!val.length) {
            const returnValue = Number(val)
            if (Number.isNaN(returnValue)) {
                return
            }
            return returnValue
        }
        if (typeof val === "number") {
            return val
        }
    }, numberValidation)
}

export function requiredNumber(min?: number, max?: number) {
    return z
        .union([z.string(), z.number(), z.undefined()])
        .refine((val) => val !== undefined, { message: "Required" })
        .transform((value) => (typeof value === "number" ? value : Number(value)))
        .pipe(minMaxNumber(min, max))
}

export function optionalNumber(min?: number, max?: number) {
    return z.optional(minMaxNumber(min, max))
}

export function errorHandling(fieldState: ControllerFieldState) {
    return {
        error: !!fieldState.error,
        errorHandling: false,
        helperText: fieldState.error?.message,
    } as Record<string, unknown>
}
